import React from "react";
import { LegalLayout } from "@/components/LegalLayout";

const CONTACT = "Robotic Lawnmower Experts, Fyanstown, Kells, Co. Meath, A82 AV90. Email: info@roboticlawnmowerexperts.ie. Phone: 089 425 9690.";

const SECTIONS = [
  { h: "Who we are", p: [
    "Robotic Lawnmower Experts (\"we\", \"us\", \"our\") is the data controller for personal data collected through this website and in the course of supplying our products and services.",
    `Contact details: ${CONTACT}`,
  ] },
  { h: "The personal data we collect", list: [
    "Contact details you give us: name, email address, phone number, county/address and eircode.",
    "Enquiry details: the product or service you're interested in, site size, club or organisation name, and anything you write in your message.",
    "Order, delivery, installation and service records, including mower model, serial number and repair history.",
    "Payment and finance records (we do not store full card details; payments are handled by our payment or finance providers).",
    "Website usage data: pages visited, date/time and browser type, collected by our own first-party analytics.",
  ] },
  { h: "Why we use your data and our legal basis", list: [
    "To respond to enquiries and provide quotes, site assessments and demonstrations — taking steps at your request before entering a contract (Article 6(1)(b) GDPR).",
    "To supply, deliver, install, service, repair and store your equipment, and to handle warranty claims — performance of a contract (Article 6(1)(b)).",
    "To keep accounting and tax records — compliance with legal obligations (Article 6(1)(c)).",
    "To run, secure and improve our website and services — our legitimate interests (Article 6(1)(f)).",
    "To send service reminders or marketing, where you have agreed — consent (Article 6(1)(a)). You can withdraw consent at any time.",
  ] },
  { h: "Who we share data with", p: [
    "We do not sell your personal data. We share it only where necessary with: manufacturers and distributors (for warranty registration and claims), courier and delivery partners, finance providers you choose to apply to, our email and website hosting providers, and our accountants and professional advisers. We may also disclose data where required by law.",
  ] },
  { h: "International transfers", p: [
    "Some of our service providers (for example, email delivery and hosting) may process data outside the European Economic Area. Where this happens, we rely on appropriate safeguards such as the European Commission's Standard Contractual Clauses or an adequacy decision.",
  ] },
  { h: "How long we keep your data", list: [
    "Enquiries that don't lead to a sale: up to 24 months, then deleted.",
    "Customer, order, warranty and service records: for the life of the product warranty plus 6 years, in line with Irish limitation periods and Revenue requirements.",
    "Website analytics data: up to 26 months.",
  ] },
  { h: "Your rights", p: [
    "Under GDPR you have the right to access your data, have it corrected or erased, restrict or object to processing, data portability, and to withdraw consent at any time. To exercise any of these rights, contact us using the details above. We will respond within one month.",
    "If you are unhappy with how we handle your data, you can complain to the Data Protection Commission, 21 Fitzwilliam Square South, Dublin 2, D02 RD28 (www.dataprotection.ie).",
  ] },
  { h: "Cookies", p: [
    "Details of the cookies and similar technologies we use are set out in our Cookie Policy.",
  ] },
  { h: "Security", p: [
    "We use appropriate technical and organisational measures to protect your data, including encrypted (HTTPS) connections and restricted access to our admin systems.",
  ] },
  { h: "Changes to this policy", p: [
    "We may update this policy from time to time. The latest version will always be published on this page with the date it was last updated.",
  ] },
];

export default function Privacy() {
  return (
    <LegalLayout
      testId="privacy-page"
      title="Privacy Policy"
      intro="This policy explains how Robotic Lawnmower Experts collects, uses and protects your personal data when you use our website, make an enquiry, or buy and service equipment with us. We comply with the EU General Data Protection Regulation (GDPR) and the Irish Data Protection Acts 1988–2018."
      sections={SECTIONS}
    />
  );
}
